import _ from 'lodash';

const order = [
    'lbx',
    'elegant',
    'relax',
    'emotion',
    'cool',
    'original',
    'original edition'
];

const endItems = [];

function compareObjectsByDesiredOrder(a, b) {
    const indexA = order.indexOf(a.name.toLowerCase());
    const indexB = order.indexOf(b.name.toLowerCase());
    return indexA - indexB;
}

function removeItem(item) {
    const isInList = order.indexOf(item.name.toLowerCase());
    if (isInList === -1) {
        return false;
    }
    return true;
}

function lbxOrder(data = []) {
    const parsedData = data
        .filter(removeItem)
        .sort(compareObjectsByDesiredOrder)
    return parsedData;
}

function createCustomShowroomItems(webglConfigurations, customTemplate) {

    const showroomItems = []

    _.forEach(webglConfigurations, (item)=> {

        const sku = item.sku;
        const atmosphereName =  _.get(item,'gradeName','LBX');
        const isBaseGrade = atmosphereName === 'LBX'

        const personaliseText = _.get(customTemplate,'personaliseCta.label');
        const personaliseLink = _.get(customTemplate,'personaliseCta.href');
        
        const reserveText = _.get(customTemplate,'reserveCta.label');
        const reserveLink = _.get(customTemplate,'reserveCta.href');

        const image1 = _.get(customTemplate,'images.0.base');
        const image3 = _.get(customTemplate,'images.1.base');

        const craftedText = _.get(customTemplate,'crafted', '').replace('{{ATMOSPHERE}}', !isBaseGrade ? atmosphereName : '')

        const showroomItem = {
            isCustom:true,
            name: atmosphereName,
            personaliseCta:{
                label: personaliseText,
                href: `${personaliseLink}?sku=${sku}`
            },
            reserveCta : {
                label: reserveText,
                href: `${reserveLink}?sku=${sku}`
            },
            images: [
                {
                    "base": image1
                },
                {
                    "base": item.image
                },
                {
                    "base": image3
                }
            ],
            crafted: craftedText,
            id: item.id
        }
        
        showroomItems.push(showroomItem)
    })

    return showroomItems;
}

function combineAndOrderItems(standardItems, customItems) {
    const atmosphereLineUp = lbxOrder(standardItems)
    const customItemsLineUp = lbxOrder(customItems)
    const newSave = _.filter(standardItems, item => item.name === 'NEW SAVE')

    return atmosphereLineUp.concat(customItemsLineUp, newSave);

} 

export {
    lbxOrder,
    createCustomShowroomItems,
    combineAndOrderItems
}